<template>
  <div class="m-carousel-dialog dialog">
    <div class="digest">
      <p class="top">
        <span>主题：</span>
        <span class="switch-btn" @click="switchHandle">切换主题</span>
      </p>
    </div>
    <van-notice-bar wrapable :scrollable="false" class="twinkling" left-icon="volume-o">
      <p class="broadcast-content">{{ `${info.company}: ${info.txt}` }}</p>
    </van-notice-bar>
    <div class="input-box">
      <div style="margin-bottom: 10px">当前广播的出价： {{ showBeans }}</div>
      <div style="margin-bottom: 10px" v-if="ranking">您的竞价预计排名： 第{{ ranking }}名</div>
      <el-input size="small" type="number" step="10" min="50" :disabled="hasJoin" placeholder="投入能量豆" @change="changeHandle" v-model="beans">
        <template slot="prepend"><span v-if="hasJoin">已</span>每天投放 </template>
      </el-input>
      <el-input v-if="hasJoin" size="small" type="number" step="10" min="10" @change="changeHandle" v-model="addBeans">
        <template slot="prepend">追加能量豆数量</template>
      </el-input>
      <el-input size="small" type="number" min="1" max="7" :disabled="hasJoin" placeholder="投入能量豆" v-model="days">
        <template slot="prepend">广播天数</template>
      </el-input>
      <div class="total-box">
        <p>
          <span class="label">合计:</span>
          <span class="price"> {{ !hasJoin ? beans * days : addBeans * days }}</span
          >能量豆
        </p>
      </div>
    </div>
    <div class="tip-box">
      <pre>
规则如下：
1. 广播采用竞价模式，出价高者获得广播资格，最小竞价周期为30分钟。
2. 通过投入更多的能量豆可以争夺广播资格，出局者根据已投放时间返还剩余能量豆。
3. 最低广播天数为一天，竞价每次增加最少10个能量豆。</pre
      >
    </div>
    <div class="btn-box">
      <el-button type="warning" :disabled="showingMsgId === info.msgId" @click="setBroadcast">
        <span v-if="showingMsgId === info.msgId">正在广播</span>
        <span v-else>提交出价</span>
      </el-button>
    </div>
  </div>
</template>
<script>
import Chat from "@/api/chat";

export default {
  data() {
    return { beans: 100, days: 1, ranking: 0, showBeans: 0, addBeans: 10 };
  },
  methods: {
    changeHandle(e) {
      const beans = Math.round(e / 10) * 10;
      if (this.hasJoin) {
        this.addBeans(beans);
      } else {
        this.beans = beans;
      }
    },
    async setBroadcast() {
      const beans = this.hasJoin ? this.addBeans : this.beans;
      if (this.beans <= this.showBeans) {
        this.$toast.fail("当前出价低于正在广播的价格");
        return false;
      }
      const result = await Chat.setBroadcast({
        beans: beans,
        msgId: this.info.msgId,
        days: this.days
      });
      if (result === true) {
        this.$toast.success("提交成功");
        this.info.bcStatus = 1;
        this.$emit("update:visible", false);
        this.$emit("success");
      } else {
        this.$toast.fail("系统出错请稍后再试");
      }
    }
  },
  computed: {
    showingMsgId() {
      return this.$store.state.showingMsgId;
    }
  },
  props: {
    hasJoin: Boolean,
    info: {},
    visible: Boolean,
    switchHandle: {
      type: Function,
      default: null
    }
  },
  created() {
    Chat.getBidding(this.info.msgId).then(res => {
      res.ShowingMsgId && this.$store.commit("setShowingMsgId", res.ShowingMsgId);
      this.showBeans = res.ShowingUnitBeans;
      if (res.Ranking) {
        this.ranking = res.Ranking;
        this.beans = res.UnitBeans;
        this.days = res.Days;
      } else {
        this.beans = this.showBeans === 0 ? 100 : this.showBeans + 10;
      }
    });
  }
};
</script>
<style lang="scss">
.m-carousel-dialog {
  .input-box {
    padding-top: 10px;
  }
  .quick-switch-btn {
    float: right;
  }
}
</style>
